'use strict';

const React = require( 'react' );
const classNames = require( 'classnames' );
const propTypes = require('prop-types');
const getAirportInfo = require( '../getAirportInfo' );
const { string, object, func } = propTypes;
const createReactClass = require('create-react-class');

const LocationDropDown = createReactClass({
  propTypes: {
    activeLocation: string,
    pageName: string,
    locations: object.isRequired,
    onSelect: func,
    className: string
  },

  getDefaultProps() {
    return {
      activeLocation: 'LGW',
      className: ''
    };
  },

  changeLocation( e ) {
    const { value } = e.target;
    const { onSelect } = this.props;
    if ( onSelect ) onSelect( value );
  },

  render() {
    const { className, activeLocation, locations, pageName } = this.props;
    const selectClass = classNames(
      className,
      {
        'l': true
      }
    );
    let selectedLocation = activeLocation;
    if ( pageName ) {
      const location = getAirportInfo( pageName );
      if ( location && location.code ) selectedLocation = location.code;
    }
    const options = Object.keys( locations ).map( location => {
      return ( <option key={ location } value={ location }>{ locations[ location ] }</option> );
    });
    return (
      <select name="Location" className={ selectClass } defaultValue={ selectedLocation } onBlur={ this.changeLocation } onChange={ this.changeLocation } data-track-name="location">
        { options }
      </select>
    );
  }
});

module.exports = LocationDropDown;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/location-dropdown.jsx